const axios = require('axios')
const QueryString = require('query-string')
const basePath = window.basePath || '';
const baseUrl = `${basePath}/web-api/v1`
const baseAdminUrl = `${basePath}/admin/web-api/v1`
const _ = require('lodash');

const commonOptions = {
  headers: {
    'Content-Type': 'application/json'
  }
}

/**
 *
 * @param {String} endpoint This should already be encoded
 * @return Promise
 */
const getRequest = (endpoint) => {
  const url = `${baseUrl}/${endpoint}`
  return axios.get(url, commonOptions)
    .then(function (response) {
      return response.data
    }, error => {
      return Promise.reject(error)
    }).catch(error => {
      return Promise.reject(error)
    })
}

/**
 *
 * @param {String} endpoint This should already be encoded
 * @return Promise
 */
const getAdminRequest = (endpoint, params) => {
  const url = `${baseAdminUrl}/${endpoint}`
  var get_url = url
  if (params) {
    get_url = url + '?' + QueryString.stringify(params)
  }

  return axios.get(get_url, commonOptions)
    .then(function (response) {
      return response.data
    }, error => {
      return Promise.reject(error)
    }).catch(error => {
      return Promise.reject(error)
    })
}

/**
 *
 * @param {String} endpoint
 * @param {Object} formData In JSON form
 */
const postRequest = (endpoint, formData = {}) => {
  const url = `${baseUrl}/${endpoint}`
  return axios.post(url, formData, commonOptions)
    .then(function (response) {
      return response.data
    }, error => {
      return Promise.reject(error)
    }).catch(error => {
      return Promise.reject(error)
    })
}

/**
 *
 * @param {String} endpoint
 * @param {Object} formData In JSON form
 */
const postAdminRequest = (endpoint, formData = {}, options = {}) => {
  const url = `${baseAdminUrl}/${endpoint}`
  return axios.post(url, formData, _.merge({}, commonOptions, options))
    .then(function (response) {
      return response.data
    }, error => {
      return Promise.reject(error)
    }).catch(error => {
      return Promise.reject(error)
    })
}

const uploadAdminRequest = (endpoint, params = {}, files = {}, options = {}) => {
  const url = `${baseAdminUrl}/${endpoint}`
  const formData = new FormData()

  Object.keys(params).forEach(prop => {
    if (Array.isArray(params[prop])) {
      params[prop].forEach(
        value => {
          formData.append(prop + "[]", value)
        }
      )
    } else {
      formData.append(prop, params[prop])
    }
  })

  Object.keys(files).forEach(prop => {
    formData.append(prop, files[prop])
  })

  return axios.post(url, formData, _.merge({}, commonOptions, options))
    .then(function (response) {
      return response.data
    }, error => {
      return Promise.reject(error)
    }).catch(error => {
      return Promise.reject(error)
    })
}
/**
 *
 * @param {String} endpoint
 * @param {Object} formData In JSON form
 */
const putAdminRequest = (endpoint, formData = {}) => {
  const url = `${baseAdminUrl}/${endpoint}`
  return axios.put(url, formData, commonOptions)
    .then(function (response) {
      return response.data
    }, error => {
      return Promise.reject(error)
    }).catch(error => {
      return Promise.reject(error)
    })
}

/**
 *
 * @param {String} endpoint
 * @param {Object} formData In JSON form
 */
const deleteAdminRequest = (endpoint, formData = {}) => {
  const url = `${baseAdminUrl}/${endpoint}`
  return axios.delete(url, formData, commonOptions)
    .then(function (response) {
      return response.data
    }, error => {
      return Promise.reject(error)
    }).catch(error => {
      return Promise.reject(error)
    })
}

module.exports = {
  getYearsAndSubjects: () => {
    return getRequest('curriculum/items?years&subjects')
  },
  getYearsAndSubjectsMapping: () => {
    return getRequest('curriculum/items?years&subjects&subject_mapping')
  },
  getAllYears: () => {
    return getRequest('curriculum/years')
  },
  getSubjects: (yearId) => {
    return getRequest(`curriculum/subjects?year_id=${yearId}`)
  },
  getCurriculumVersions: (yearId, subjectId) => {
    return getRequest(`curriculum/curriculum-versions?year_id=${yearId}&subject_id=${subjectId}`)
  },
  getSyllabuses: (yearId, subjectId, curriculumVersionId) => {
    return getRequest(`curriculum/syllabuses?year_id=${yearId}&subject_id=${subjectId}&curriculum_version_id=${curriculumVersionId}`);
  },
  getLearningSkills: (yearId, subjectId, curriculumVersionId) => {
    return getRequest(`curriculum/learning-skills?year_id=${yearId}&subject_id=${subjectId}&curriculum_version_id=${curriculumVersionId}`)
  },
  getLearningSkillsV2: (yearId, subjectId, curriculumVersionId) => {
    return getRequest(`curriculum/learning-skills-v2?year_id=${yearId}&subject_id=${subjectId}&curriculum_version_id=${curriculumVersionId}`)
  },
  siteSearch: (queryParams) => {
    const paramString = QueryString.stringify(queryParams)
    return getRequest(`sites?${paramString}`)
  },
  addSite: (frogstore_site_uuid, hide_tutorial) => {
    return postRequest('user/me/sites', {
      frogstore_site_uuid,
      hide_tutorial: hide_tutorial | 0
    })
  },
  saveUserYearPreference: (year) => {
    return postRequest('year/favorite', {
      year
    })
  },
  getUserYearPreference: () => {
    return getRequest('user/year')
  },
  getMe: () => {
    return getRequest('user/me')
  },
  getTemplateKeyword: () => {
    return getRequest('user/me/frogmaker-keyword')
  },
  disableTutorial: () => {
    return postRequest('user/me/disable-tutorial')
  },
  lessonSearch: (queryParams) => {
    const paramString = QueryString.stringify(queryParams)
    return getRequest(`lessons?${paramString}`)
  },
  lessonRecommendation: (year, subject) => {
    const paramString = QueryString.stringify({ year, subject })
    return getRequest(`lesson/recommendation?${paramString}`)
  },
  //admin functions
  adminSiteSearch: (queryParams) => {
    const paramString = QueryString.stringify(queryParams)
    return getAdminRequest(`sites?${paramString}`)
  },
  adminGetLearningSkills: (subjectId, yearId) => {
    return getAdminRequest(`curriculum/learning-skills?subject_id=${subjectId}&year_id=${yearId}`)
  },
  adminGetYearsAndSubjects: () => {
    return getAdminRequest('curriculum/items?years&subjects')
  },
  adminTriggerImport: () => {
    return postAdminRequest('system/trigger-import')
  },
  adminGetSite: (itemId) => {
    return getAdminRequest(`site/${itemId}`)
  },
  adminUpdateItem: (itemId, params) => {
    return putAdminRequest(`site/${itemId}`, params)
  },
  adminDoRecrawl: (itemId) => {
    return postAdminRequest(`system/trigger-replace/${itemId}`)
  },
  adminCreateItemCollection: (params) => {
    return postAdminRequest('item-collection', params)
  },
  adminCreateChallengeItemCollection: (params) => {
    return postAdminRequest('challenge-item-collection', params)
  },
  adminGetItemCollection: (id) => {
    return getAdminRequest(`item-collection/${id}`)
  },
  adminGetChallengeItemCollection: (id) => {
    return getAdminRequest(`challenge-item-collection/${id}`)
  },
  adminGetItemCollections: (params) => {
    return getAdminRequest('item-collections', params)
  },
  adminGetAvailableCollectionTypes: () => {
    return getAdminRequest('item-collection-types')
  },
  adminUploadCollectionImage: (id, files) => {
    return uploadAdminRequest(`item-collection/${id}/image`, {}, files)
  },
  adminUploadChallengeCollectionImage: (id, files) => {
    return uploadAdminRequest(`challenge-item-collection/${id}/image`, {}, files)
  },
  adminUploadMediaImage: (params, file) => {
    return uploadAdminRequest(`image/upload`, params, file, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
  },
  adminUploadVideoPreview: (params, file) => {
    return uploadAdminRequest(`videos/upload-preview`, params, file, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
  },
  adminUploadVideoThumbnail: (params, file) => {
    return uploadAdminRequest(`videos/upload-thumbnail`, params, file, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
  },
  adminUploadVideo: (params) => {
    return postAdminRequest(`videos/upload`, params)
  },
  adminUpdateCollection: (id, params) => {
    return putAdminRequest(`item-collection/${id}`, params)
  },
  adminUpdateChallengeCollection: (id, params) => {
    return putAdminRequest(`challenge-item-collection/${id}`, params)
  },
  adminGetTags: (type, value) => {
    const paramString = QueryString.stringify({ type, value })
    return getAdminRequest(`tags?${paramString}`)
  },
  adminGetTagCount: (type, value) => {
    const paramString = QueryString.stringify({ type, value })
    return getAdminRequest(`tags/item-count?${paramString}`)
  },
  adminGetItemTag: (keyword, item_id) => {
    const paramString = QueryString.stringify({ keyword, item_id })
    return getAdminRequest(`tags/item-tag?${paramString}`)
  },
  adminUpdateCollectionStatus: (id, status) => {
    return postAdminRequest(`item-collection/${id}/status`, { status })
  },
  adminUpdateChallengeCollectionStatus: (id, status) => {
    return postAdminRequest(`challenge-item-collection/${id}/status`, { status })
  },
  adminRemoveFrogMakerKeyword: () => {
    //hard code for security
    return postAdminRequest('system/remove-keyword', {
      keyword: 'frogmaker-template'
    })
  },
  adminRemoveFrogMakerKeywordByBulk: (itemIds) => {
    //hard code for security
    return postAdminRequest('system/remove-keyword-bulk', {
      keyword: 'frogmaker-template',
      itemIds: itemIds
    })
  },
  adminGetPublishers: () => {
    return getAdminRequest(`publishers`)
  },
  adminMediaSearch: (params) => {
    const paramString = QueryString.stringify(params, { arrayFormat: 'bracket' })
    return getAdminRequest(`items?${paramString}`)
  },
  adminGetMedia: (id) => {
    return getAdminRequest(`media/${id}`)
  },
  adminDeleteMedia: (id) => {
    return postAdminRequest(`media/delete/${id}`)
  },
  adminUpdateMedia: (itemId, params) => {
    return putAdminRequest(`media/${itemId}`, params)
  },
  adminAttachChallengeItem: (collectionId, itemId, CTAButtonEnabled) => {
    return postAdminRequest(`item-collection/${collectionId}/attach-item/${itemId}`, { collection_id: collectionId, item_id: itemId, show_cta: CTAButtonEnabled})
  },
  adminAttachChallengeQuiz: (collectionId, subjectId, yearId, quizId, quizCTAButtonEnabled) => {
    return postAdminRequest(`item-collection/${collectionId}/attach-quiz`, { collection_id: collectionId, subject_id: subjectId, year_id: yearId, quiz_id: quizId, show_cta: quizCTAButtonEnabled })
  },
  adminUploadChallengeFile: (collectionId, challengeQuizId, files, type) => {
    return uploadAdminRequest(`item-collection/${collectionId}/${type}/${challengeQuizId}/image`, {}, files, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
  },
  adminDetachChallengeItem: (id, collectionId) => {
    return postAdminRequest(`item-collection/${collectionId}/detach-item/${id}`, { id: id, collection_id: collectionId })
  },
  adminDetachChallengeQuiz: (id, collectionId) => {
    return postAdminRequest(`item-collection/${collectionId}/detach-quiz`, { id: id, collection_id: collectionId })
  },
  adminDeleteCollection: (id) => {
    return postAdminRequest(`item-collection/delete/${id}`)
  },
  adminGetSitesGroup: () => {
    return getAdminRequest(`sites/group`)
  },
  adminPostSitesGroupPublish: (params) => {
    return postAdminRequest(`sites/group/publish`, params)
  },
  adminPostSitesGroupUnpublish: (params) => {
    return postAdminRequest(`sites/group/unpublish`, params)
  },
  adminPostSystemTriggerContentCache: () => {
    return postAdminRequest(`system/trigger-content-cache`)
  },
  adminCreateDiscover: (params) => {
    return postAdminRequest('discover/create', params, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
  },
  adminGetDiscovers: () => {
    return getAdminRequest('discovers')
  },
  adminDeleteDiscover: (id) => {
    return postAdminRequest(`discover/delete/${id}`)
  },
  adminUpdateDiscover: (id, params) => {
    return postAdminRequest(`discover/update/${id}`, params)
  },
  adminGetWhitelistPublishers: (params) => {
    return getAdminRequest(`whitelist-publishers`, params)
  },
  adminAddPushlisherToWhiteList: (params) => {
    return postAdminRequest(`whitelist-publishers/create`, params)
  },
  adminRemovePushlisherFromWhiteList: (id) => {
    return postAdminRequest(`whitelist-publishers/delete/${id}`)
  },
  adminGetContentTagsBoost: (param) => {
    return getAdminRequest(`content-tags-boost`, param)
  },
  adminAddContentTagsCorrectFrom: (params) => {
    return postAdminRequest(`content-tags-boost/save`,{...params})
  },
  adminExportExcelCorrect: (params) => {
    return getAdminRequest(`content-tags-boost/export-excel`,params)
  }
}
